import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProductGroupService {
  is_display_product_group_register_component = false;
  productGroupUpdate = new EventEmitter<ProductGroup>();

  downloadProductGroup = new EventEmitter<boolean>();
  private _product_group_data: ProductGroup = null;

  constructor() { }
  set set_product_group_data(product_group) {
    this._product_group_data = product_group;
  }

  get get_product_group_data() {
    return this._product_group_data;
  }
}

export interface ProductGroup {
  id: number;
  name: string;
}
